import {Component, Input} from '@angular/core';
import {NgIf} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {GeneralService} from "../../../../core/services/general.service";
import {AddressComponent} from "../../backlog/address/address.component";
import {ListService} from "../../../../core/services/list.service";

@Component({
  selector: 'app-personal-data',
  standalone: true,
    imports: [
        NgIf
    ],
  templateUrl: './personal-data.component.html',
  styleUrl: './personal-data.component.scss'
})
export class PersonalDataComponent {
  @Input() confirmAction!: (data: any) => void;
  @Input() data: any;
  @Input() title: any;

  public personalData: any = {};
  constructor(public modal :NgbModal,private generalService:GeneralService, private listService:ListService) {
  }

  ngOnInit(): void {
   this.getPersonalData();
  }

  getPersonalData(){
    this.listService.getPersonalData(this.data).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
          } else {
            this.personalData = res.data;
          }
        },
        (err) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
        }
    );
  }

}
